import { getDeviceType } from '@/assets/js/common'

export default [
  {
    path: '/:system/pc',
    component: () => import(/* webpackChunkName: "support" */ '@/views/support/pc/index'),
    children: [
      {
        path: 'index',
        name: 'pc_index',
        component: () => import(/* webpackChunkName: "support" */ '@/views/support/pc/faq_list')
      },
      {
        path: 'detail',
        name: 'pc_detail',
        component: () => import(/* webpackChunkName: "support" */ '@/views/support/pc/detail')
      }
    ],
    meta: {
      title: '我的客服'
    }
  },
  {
    path: '/:system/pcSearch',
    name: 'pc_search',
    component: () => import(/* webpackChunkName: "support" */ '@/views/support/pc/search'),
    meta: {
      title: '我的客服'
    }
  },
  {
    path: '/:system/mobile/index',
    name: 'mobile_index',
    component: () => import(/* webpackChunkName: "support" */ '@/views/support/mobile/index'),
    meta: {
      title: '我的客服'
    }
  },
  {
    path: '/:system/mobile/detail',
    name: 'mobile_detail',
    component: () => import(/* webpackChunkName: "support" */ '@/views/support/mobile/detail'),
    meta: {
      title: '我的客服'
    }
  },
  {
    path: '/:system/index.html', // 处理特定路径
    redirect: (to) => {
      const system = to.params.system
      if (system) {
        const currentDevice = getDeviceType() // 获取当前设备类型
        const searchParam = to.query // 获取查询参数
        let sNewUrl = `/${system}/${currentDevice}/index`
        if (searchParam) {
          sNewUrl += `?${new URLSearchParams(searchParam).toString()}`
        }
        return sNewUrl
      }
    }
  },
  {
    path: '/:system/:device/index.html', // 处理PC端和移动端index.html路径
    redirect: (to) => {
      const { system, device } = to.params
      if (system && (device === 'pc' || device === 'mobile')) {
        const searchParam = to.query // 获取查询参数
        let sNewUrl = `/${system}/${device}/index`
        if (searchParam) {
          sNewUrl += `?${new URLSearchParams(searchParam).toString()}`
        }
        return sNewUrl
      }
    }
  },
  {
    path: '/404',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "error" */ '@/views/404'),
    meta: {
      title: '404'
    }
  },
  {
    path: '/500',
    name: 'serverError',
    component: () => import(/* webpackChunkName: "error" */ '@/views/500'),
    meta: {
      title: '500'
    }
  },
  {
    path: '/:pathMatch(.*)',
    redirect: () => {
      return { path: '/404' }
    }
  }
]
